import React from 'react'
import FormHelper from '../../../utils/FormHelper'
import Service from './change-password.service'
import Form from './form/form.component'
import { withRouter } from 'react-router-dom'
import { connect } from 'react-redux'

class ChangePassword extends React.Component {

    constructor(props) {
        super(props)
        this.service = Service(this)
        this.state = this.service.getDefaultState()
    }

    onSubmit = (e) => {
        e.preventDefault()
        this.service.isValid() && this.service.chanegPassword()
    }

    onCancel = () => {
        this.props.history.push('/')
    }

    render() {
        return (
            <div className="create">
                <div className="header">
                    <h4>Change Password</h4>
                </div>
                <br/>
                <div className="card">
                    <div className={"flag " + this.state.flag.type}>
                        {this.state.flag.text}
                    </div>
                    <Form {...this.state} onChange={FormHelper(this).onChange} onSubmit={this.onSubmit} onCancel={this.onCancel} />
                </div>
            </div>
        )
    }
}

const mapStateToProps = (state) => {
    return {
        auth: state.auth
    }
}

export default connect(mapStateToProps)(withRouter(ChangePassword))